// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Press_pageContainer__1JSXO"};